import { render, staticRenderFns } from "./IncentiveTagsFilter.vue?vue&type=template&id=edf7f5c6&scoped=true"
import script from "./IncentiveTagsFilter.vue?vue&type=script&lang=js"
export * from "./IncentiveTagsFilter.vue?vue&type=script&lang=js"
import style0 from "./IncentiveTagsFilter.vue?vue&type=style&index=0&id=edf7f5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf7f5c6",
  null
  
)

export default component.exports